/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as utilService from '../services/utilService'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import Joinnowpopup from './sub_components/joinnowpopup'
import Loginpopup from './sub_components/loginpopup'
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

 let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class ExchangeNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection : "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]:false })
        
    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })
        
    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = ""){
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name){
        this.setState({selectedSection: this.state.selectedSection === name ? "" : name});
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
        <div className="radheexch radheexchlogin bg-white-login vsportbg">
            
            
            <Loginb2cHeader history={this.props.history}></Loginb2cHeader>
        {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
        <div className='login-mar-top100 bg-black'>
                <section className='sportbook-livecasino'>
                    <div>
                        <img alt="Exchange Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchanges-banner.jpg"}  />

                    </div>
                    <div className='exchangepage'>
                        <div className='exchange-box'>
                            <div className="exchange-label" >
                                <span className="exchange-label-title">National teams. Twenty20. 2nd Match</span>
                            </div>
                            <div className='exchange-wrapper'>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                                <div className='styles_time-status-wrapper__38QnX'>
                                    <div className="styles_wrapper__3f1Pr">
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/tv.svg`} className='exchange-tvicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/bm-icon1.svg`} className='exchange-bmicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/fancy-icon1.svg`} className='exchange-fancyicon'/>
                                    </div>
                                    <div className="exchange-icon">
                                        <span className="icon-start-date">Today</span>
                                        <span className="icon-start-time">23:00</span>
                                    </div>
                                </div>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                            </div>
                            <div className='exchange-box-f'>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-price '>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-title'>-</div>
                                    <div className='ebox-f1-price'>-</div>
                                </div>
                                <div className='exchange-box-f1'>
                                <div className='ebox-f1-price'>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                            </div>
                        </div>
                        <div className='exchange-box'>
                            <div className="exchange-label" >
                                <span className="exchange-label-title">National teams. Twenty20. 2nd Match</span>
                            </div>
                            <div className='exchange-wrapper'>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                                <div className='styles_time-status-wrapper__38QnX'>
                                    <div className="styles_wrapper__3f1Pr">
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/tv.svg`} className='exchange-tvicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/bm-icon1.svg`} className='exchange-bmicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/fancy-icon1.svg`} className='exchange-fancyicon'/>
                                    </div>
                                    <div className="exchange-icon">
                                        <span className="icon-start-date">Today</span>
                                        <span className="icon-start-time">23:00</span>
                                    </div>
                                </div>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                            </div>
                            <div className='exchange-box-f'>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-price '>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-title'>-</div>
                                    <div className='ebox-f1-price'>-</div>
                                </div>
                                <div className='exchange-box-f1'>
                                <div className='ebox-f1-price'>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                            </div>
                        </div>
                        <div className='exchange-box'>
                            <div className="exchange-label" >
                                <span className="exchange-label-title">National teams. Twenty20. 2nd Match</span>
                            </div>
                            <div className='exchange-wrapper'>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                                <div className='styles_time-status-wrapper__38QnX'>
                                    <div className="styles_wrapper__3f1Pr">
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/tv.svg`} className='exchange-tvicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/bm-icon1.svg`} className='exchange-bmicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/fancy-icon1.svg`} className='exchange-fancyicon'/>
                                    </div>
                                    <div className="exchange-icon">
                                        <span className="icon-start-date">Today</span>
                                        <span className="icon-start-time">23:00</span>
                                    </div>
                                </div>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                            </div>
                            <div className='exchange-box-f'>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-price '>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-title'>-</div>
                                    <div className='ebox-f1-price'>-</div>
                                </div>
                                <div className='exchange-box-f1'>
                                <div className='ebox-f1-price'>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                            </div>
                        </div>
                        <div className='exchange-box'>
                            <div className="exchange-label" >
                                <span className="exchange-label-title">National teams. Twenty20. 2nd Match</span>
                            </div>
                            <div className='exchange-wrapper'>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                                <div className='styles_time-status-wrapper__38QnX'>
                                    <div className="styles_wrapper__3f1Pr">
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/tv.svg`} className='exchange-tvicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/bm-icon1.svg`} className='exchange-bmicon'/>
                                      <img src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/fancy-icon1.svg`} className='exchange-fancyicon'/>
                                    </div>
                                    <div className="exchange-icon">
                                        <span className="icon-start-date">Today</span>
                                        <span className="icon-start-time">23:00</span>
                                    </div>
                                </div>
                                <div className='exchange-teamname exchange-teamname-title'>
                                    <span>Team 1</span>
                                </div>
                            </div>
                            <div className='exchange-box-f'>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-price '>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                                <div className='exchange-box-f1'>
                                    <div className='ebox-f1-title'>-</div>
                                    <div className='ebox-f1-price'>-</div>
                                </div>
                                <div className='exchange-box-f1'>
                                <div className='ebox-f1-price'>1.87</div>
                                    <div className='ebox-f1-price'>2.54</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <Loginb2cFooter history={this.props.history}></Loginb2cFooter>

            
            {this.state.showPopup && <Joinnowpopup hidePopup={() => { this.hidePopup() }} showSweetAlert={(options) =>this.props.showSweetAlert(options)}  notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} toggleSelectedSection={(name)=>{ this.toggleSelectedSection(name) }}/>}
            {this.state.showLoginPopup && <Loginpopup hidePopup={() => { this.hidePopup("Login") }} showSweetAlert={(options) =>this.props.showSweetAlert(options)} history={this.props.history} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)}/>}
        </div>)
        
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExchangeNew);